<div class="table-outer-wrapper" [ngClass]="'table-' + uniqueId">
  <!-- Header: Scrolls horizontally with body, but stays fixed vertically -->
  <div class="header-container" #headerContainer
       [tableColumnManager]="uniqueId"
       [defaultWidths]="defaultWidths"
       [columnGroups]="columnGroups"
       [settings]="settings"
       (settingsChange)="onSettingsChange.emit($event)">
    <div class="table-inner-wrapper">
      <div class="services-table-list-container">
        <div class="tr sticky-header">
          <!-- Merged header for checkbox and ID -->
          <div class="th col-id sticky-col layout-row layout-align-start-center gap-5">
            <span *ngIf="settings?.columns?.id" class="margin-left-5" translate>Service</span>
            <app-table-column-insert-button></app-table-column-insert-button>
          </div>

          @if (settings?.columns?.account) {
            <div class="th col-account" translate>
              Account
              <app-table-column-insert-button column="account"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.contact) {
            <div class="th col-contact" translate>
              Contact
              <app-table-column-insert-button column="contact"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.proNumber) {
            <div class="th col-pro-number" translate>
              Pro Number
              <app-table-column-insert-button column="proNumber"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.location) {
            <div class="th col-location" translate>
              Stops
              <app-table-column-insert-button column="location"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.timeWindow) {
            <div class="th col-time-window" translate>
              Time Window
              <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.serviceTime) {
            <div class="th col-service-time" translate>
              Service Time
              <app-table-column-insert-button column="serviceTime"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.route) {
            <div class="th col-route" translate>
              Route
              <app-table-column-insert-button column="route"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.resource) {
            <div class="th col-resource" translate>
              Resource
              <app-table-column-insert-button column="resource"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.packages) {
            <div class="th col-packages" translate>
              Packages
              <app-table-column-insert-button column="packages"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.tags) {
            <div class="th col-tags" translate>
              Tags
              <app-table-column-insert-button column="tags"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.skills) {
            <div class="th col-skills" translate>
              Skills
              <app-table-column-insert-button column="skills"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.price) {
            <div class="th col-price" translate>
              Price
              <app-table-column-insert-button column="price"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.relations) {
            <div class="th col-relations" translate>
              Relations
              <app-table-column-insert-button column="relations"></app-table-column-insert-button>
            </div>
          }
          <!-- Load Columns -->
          @if (settings?.load?.weight) {
            <div class="th col-load col-load-weight" translate>
              Weight
              <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.volume) {
            <div class="th col-load col-load-volume" translate>
              Volume
              <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.packages) {
            <div class="th col-load col-load-packages" translate>
              Packages
              <app-table-column-insert-button column="packages" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.pallets) {
            <div class="th col-load col-load-pallets" translate>
              Pallets
              <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.spots) {
            <div class="th col-load col-load-spots" translate>
              Spots
              <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.value) {
            <div class="th col-price col-load-value" translate>
              Value
              <app-table-column-insert-button column="value" group="load"></app-table-column-insert-button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="body-container-wrapper"
       cdkDropList
       id="{{panel.id}}"
       [cdkDropListData]="vm?.services"
       [cdkDropListConnectedTo]="allPanelIds"
       [cdkDropListEnterPredicate]="enterPredicate"
       (cdkDropListDropped)="drop($event)">

    <div *ngIf="!vm?.loading && !vm?.services?.length" class="flex layout-row layout-align-center-center padding-20">
      <app-empty-state src="assets/images/empty_state/empty_state_dispatching.png" text="No Services found"></app-empty-state>
    </div>

    <!-- Body: Handles vertical scrolling (starting under header) and horizontal scrolling -->
    <cdk-virtual-scroll-viewport *ngIf="vm?.services?.length"
                                 class="body-container"
                                 [itemSize]="31"
                                 (scroll)="onBodyScroll($event)">

      <div class="table-inner-wrapper">
        <div class="services-table-list-container">
          <ng-container>
            <div *cdkVirtualFor="let service of vm?.services; trackBy: trackById"
                 class="tr"
                 [ngClass]="{'selected': selectedKeys[service.id]}"
                 (contextmenu)="onRightClick($event, service)"
                 cdkDrag
                 [cdkDragData]="service">

            <div *ngIf="selectedIds?.length > 1 && selectedKeys[service.id]; else normalPreview">
              <div *cdkDragPreview id="app-planning-draft-jobs-panel-editable-list-preview-drag-multiple-jobs-container">
                {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedIds.length} }}
              </div>
            </div>

            <ng-template #normalPreview>
              <div *cdkDragPreview class="drag-preview tr">
                 <div class="td col-id">
                    {{ service.externalId || service.id }}
                 </div>
              </div>
            </ng-template>

            <!-- Placeholder -->
            <div *cdkDragPlaceholder class="drag-placeholder"></div>

            <!-- Merged Sticky Column: Checkbox + ID -->
            <div class="td col-id sticky-col layout-row layout-align-start-center gap-5">
              <div cdkDragHandle style="display: flex; align-items: center; flex-shrink: 0;">
                <bringoz-icon iconName="drag" class="secondary-100 pointer"></bringoz-icon>
              </div>

              <app-bringoz-checkbox [isChecked]="selectedKeys[service.id]"
                                    (clickEvent)="onToggleSelection(service.id, !selectedKeys[service.id])"
                                    style="flex-shrink: 0; display: flex;">
              </app-bringoz-checkbox>

              <div *ngIf="settings?.columns?.id" class="flex layout-row layout-align-start-center text-ellipsis gap-5" style="min-width: 0;">
                <app-bringoz-status-tag [status]="service.status"
                                        [extraTooltipText]="service?.cancellationReason?.reason"
                                        [isSmall]="true">
                </app-bringoz-status-tag>
                <app-service-link [serviceType]="service.serviceType"
                                  [id]="service.id"
                                  [externalId]="service.externalId"
                                  isAllowCopyButton="true"
                                  class="text-ellipsis">
                </app-service-link>
                <app-service-type-indication [serviceType]="service.serviceType" [isShort]="true"></app-service-type-indication>
              </div>
            </div>

            <!-- Account -->
            <div *ngIf="settings?.columns?.account" class="td col-account text-ellipsis">
              <app-demand-account-link class="text-ellipsis" style="width: 100%;" [account]="service.account"></app-demand-account-link>
            </div>

            <!-- Contact -->
            <div *ngIf="settings?.columns?.contact" class="td col-contact layout-column gap-5 text-ellipsis">
              <div *ngFor="let task of service.taskList" class="layout-row layout-align-start-center gap-5 text-ellipsis">
                <bringoz-icon iconName="contact-circle" classSize="md" [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"></bringoz-icon>
                <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.contact?.name || '---' }}</span>
              </div>
            </div>

            <!-- Pro Number -->
            <div *ngIf="settings?.columns?.proNumber" class="td col-pro-number layout-row layout-align-start-center gap-5 text-ellipsis">
              <bringoz-icon iconName="hash" classSize="md" fill="#484848"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{service.proNumber || '---'}}</span>
            </div>

            <!-- Stops (Addresses) -->
            <div *ngIf="settings?.columns?.location" class="td col-location layout-column gap-5 text-ellipsis">
              <div *ngFor="let task of service.taskList" class="layout-row layout-align-start-center gap-5 text-ellipsis">
                <app-task-purpose [purpose]="task.taskSpec?.purpose" [firstLetterOnly]="true"></app-task-purpose>
                <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.address | bringozAddress }}</span>
              </div>
            </div>

            <!-- Time Window -->
            <div *ngIf="settings?.columns?.timeWindow" class="td col-time-window layout-column gap-5 text-ellipsis">
              <div *ngFor="let task of service.taskList" class="layout-row layout-align-start-center gap-5 text-ellipsis">
                <bringoz-icon iconName="time-window-outline" classSize="md" [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"></bringoz-icon>
                <span class="br-body-1 text-ellipsis">{{ task.taskSpec | timeWindow }}</span>
              </div>
            </div>

            <!-- Service Time -->
            <div *ngIf="settings?.columns?.serviceTime" class="td col-service-time layout-column gap-5 text-ellipsis">
              <div *ngFor="let task of service.taskList" class="layout-row layout-align-start-center gap-5 text-ellipsis">
                <bringoz-icon iconName="timer-outline" classSize="md" [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"></bringoz-icon>
                <div *ngIf="!task.taskSpec?.detailedServiceTime" class="layout-row layout-align-start-center">
                  <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.serviceTime | bringozTimeConvert: true }}</span>
                </div>
                <app-task-detailed-service-time *ngIf="!!task.taskSpec?.detailedServiceTime"
                                                class="margin-left-5 text-ellipsis"
                                                [fontSize]="'br-body-1'"
                                                [isAllowEdit]="false"
                                                [detailedServiceTime]="task.taskSpec?.detailedServiceTime">
                </app-task-detailed-service-time>
              </div>
            </div>

            <!-- Route -->
            <div *ngIf="settings?.columns?.route" class="td col-route text-ellipsis">
               <span class="br-body-1 text-ellipsis"
                     [ngClass]="{'clickable-route-id': !!service.routeId}"
                     (click)="service.routeId && onRouteIdClick($event, service.routeId)">{{service.routeId || '---'}}</span>
            </div>

            <!-- Resource -->
            <div *ngIf="settings?.columns?.resource" class="td col-resource text-ellipsis">
               <span class="br-body-1 text-ellipsis">{{service.routeReference?.resourceName || '---'}}</span>
            </div>

            <!-- Packages -->
            <div *ngIf="settings?.columns?.packages" class="td col-packages text-ellipsis">
              <app-bringoz-packages-items-display-list *ngIf="!!service && service?.packageList?.length"
                                                       [items]="service.packageList[0].items">
              </app-bringoz-packages-items-display-list>
            </div>

            <!-- Tags -->
            <div *ngIf="settings?.columns?.tags" class="td col-tags text-ellipsis">
              <app-bringoz-tags *ngIf="!!service.tags?.length" [tags]="service.tags" [maxTags]="1"></app-bringoz-tags>
              <span *ngIf="!service.tags?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Skills -->
            <div *ngIf="settings?.columns?.skills" class="td col-skills text-ellipsis">
               <app-skill-tags *ngIf="service.requiredSkills?.length" [skillsIds]="service.requiredSkills" [limit]="1"></app-skill-tags>
               <span *ngIf="!service.requiredSkills?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Price -->
            <div *ngIf="settings?.columns?.price" class="td col-price text-ellipsis">
              <span class="br-body-1 text-ellipsis">{{ service.billingReference?.courierPrice | bringozPrice: '---' }}</span>
            </div>

            <!-- Relations -->
            <div *ngIf="settings?.columns?.relations" class="td col-relations">
              <app-task-relations-indicator [relations]="relationsMap[service.id]"
                                            (onClick)="onRelationsClick($event, service)">
              </app-task-relations-indicator>
            </div>

            <!-- Loads -->
            <div *ngIf="settings?.load?.weight" class="td col-load col-load-weight text-ellipsis gap-5">
              <span class="br-body-1 text-ellipsis">{{ service.packageList | packageWeight:true }}</span>
            </div>

            <div *ngIf="settings?.load?.volume" class="td col-load col-load-volume text-ellipsis gap-5">
              <span class="br-body-1 text-ellipsis">{{ service.packageList | packageVolume:true }}</span>
            </div>

            <div *ngIf="settings?.load?.packages" class="td col-load col-load-packages text-ellipsis gap-5">
              <span class="br-body-1 text-ellipsis">{{ service.packageList | packageTotalItems }}</span>
            </div>

            <div *ngIf="settings?.load?.pallets" class="td col-load col-load-pallets text-ellipsis gap-5">
              <span class="br-body-1 text-ellipsis">{{ service.packageList | packagePallets }}</span>
            </div>

            <div *ngIf="settings?.load?.spots" class="td col-load col-load-spots text-ellipsis gap-5">
              <span class="br-body-1 text-ellipsis">{{ service.packageList | packageSpots }}</span>
            </div>

            <!-- Price -->
            <div *ngIf="settings?.load?.value" class="td col-price col-load-value text-ellipsis">
              <span class="br-body-1 text-ellipsis">{{ service.packageList | packageTotalValue }}</span>
            </div>

          </div>
        </ng-container>
      </div>
    </div>

  </cdk-virtual-scroll-viewport>
  </div>

  <app-bringoz-linear-progress *ngIf="vm?.loading"></app-bringoz-linear-progress>
</div>
